module.exports = __webpack_public_path__ + "media/paliwa/pb_95-83575fe9.png";